<template>
  <div class="form-dialog">
    <div class="form-body-scroll">
      <div class="form-title padding-title">
        {{ title }}
      </div>
      <div class="form-box-body">
        <vuescroll>
          <div class="form-components scroll">
            <div
              class="form_combo_text"
              v-text="text"
            />
            <!-- 1 -->
            <div
              class="form_label"
              v-text="'Nombre Completo*'"
            />
            <div class="form__field">
              <label for="name"><v-icon
                name="user"
                scale="1"
              /></label>
              <input
                id="name"
                ref="name"
                v-model="name"
                autocomplete="off"
                type="text"
                name="name"
                value=""
                placeholder="Nombre"
                required
                @focus="_clearError"
                @keypress="keyPressCheckSpecialChars($event, 'name')"
                @change="cleanSpecialChars('name', 'name')"
              >
            </div>
            <!-- 2 -->
            <div
              class="form_label"
              v-text="'Correo electrónico *'"
            />
            <div class="form__field">
              <label
                for="correo"
              ><v-icon
                name="envelope"
                scale="1"
              /></label>
              <input
                id="correo"
                ref="correo"
                v-model="correo"
                class="correo"
                autocomplete="off"
                type="text"
                name="correo"
                value=""
                placeholder="usuario@dominio.com"
                required
                @focus="_clearError"
              >
            </div>
            <!-- 3 -->
            <div
              class="form_label"
              v-text="'Teléfono *'"
            />
            <div class="form__field">
              <label
                for="telefono"
              ><v-icon
                name="mobile-alt"
                scale="1"
                style="margin: 0 2px 3px 4px"
              /></label>
              <input
                id="telefono"
                ref="telefono"
                v-model="telefono"
                autocomplete="off"
                type="text"
                name="telefono"
                value=""
                placeholder="+569 1 234 5678"
                required
                @focus="_clearError"
                @keypress="keyPressCheckSpecialChars($event, 'phone')"
                @change="cleanSpecialChars('telefono', 'phone')"
              >
            </div>
            <!-- 4 -->
            <div
              class="form_label"
              v-text="'RUT *'"
            />
            <div class="form__field">
              <label
                for="rut"
              ><v-icon
                name="address-card"
                scale="1"
              /></label>
              <input
                id="rut"
                ref="rut"
                v-model="rut"
                autocomplete="off"
                type="text"
                name="rut"
                value=""
                placeholder="XX.XXX.XXX-X"
                required
                @focus="_clearError"
                @keypress="keyPressCheckSpecialChars($event, 'rut')"
                @change="_formatearRut($event.target.value)"
              >
            </div>
            <!-- 5 -->
            <div
              class="form_label"
              v-text="'Ciudad *'"
            />
            <div class="form__field">
              <label
                for="ciudad"
              ><v-icon
                name="city"
                scale="1"
              /></label>
              <input
                id="ciudad"
                ref="ciudad"
                v-model="ciudad"
                autocomplete="off"
                type="text"
                name="ciudad"
                value=""
                placeholder="Santiago"
                required
                @focus="_clearError"
                @keypress="keyPressCheckSpecialChars($event, 'ciudad')"
                @change="cleanSpecialChars('ciudad', 'ciudad')"
              >
            </div>
            <!-- 6 -->
            <div
              class="form_label"
              v-text="'Filial'"
            />
            <div class="form__field">
              <select
                id="form_estilos"
                v-model="filial"
                :multiple="false"
                class="form_combo"
              >
                <option value>
                  SELECCIONAR...
                </option>
                <option value="Cervecería CCU">
                  Cervecería CCU
                </option><option value="Embotelladoras Chilenas Unidas S.A.">
                  Embotelladoras Chilenas Unidas S.A.
                </option><option value="Compañía Pisquera de Chile S.A.">
                  Compañía Pisquera de Chile S.A.
                </option><option value="Viña San Pedro Tarapacá S.A.">
                  Viña San Pedro Tarapacá S.A.
                </option><option value="Aguas CCU - Nestlé S.A.">
                  Aguas CCU - Nestlé S.A.
                </option><option value="Transportes CCU">
                  Transportes CCU
                </option>
              </select>
            </div>
            <!-- TEXTAREA -->
            <div
              class="score-subtitle"
              style="margin-bottom: 5px;"
            >
              Mensaje
            </div>
            <div class="score-comments">
              <textarea
                v-model="mensaje"
                placeholder="Deja tu mensaje"
                @keypress="keyPressCheckSpecialChars($event, 'mensaje')"
                @change="cleanSpecialChars('mensaje', 'mensaje')"
              />
            </div>
          </div>
        </vuescroll>
      </div>

      <!-- BOTONES -->
      <div class="form-box-button scroll margin_btn">
        <button
          class="button-secondary"
          @click="_cancelClick"
        >
          Cancelar
        </button>
        <button
          class="button-primary"
          @click="_sentClick"
        >
          Enviar
        </button>
      </div>
      <!-- MSG -->
      <div class="form-error">
        &nbsp;{{ errormsg }}
      </div>
    </div>
  </div>
</template>
<script>
import { serverUI } from './main'
import Icon from 'vue-awesome/components/Icon'
import 'vue-awesome/icons/map-marker-alt'
import 'vue-awesome/icons/user'
import 'vue-awesome/icons/store'
import 'vue-awesome/icons/comment'
import 'vue-awesome/icons/id-card'
import 'vue-awesome/icons/barcode'
import 'vue-awesome/icons/clock'
import 'vue-awesome/icons/tools'
import 'vue-awesome/icons/mobile-alt'
import utils from './utils'

export default {
  components: {
    'v-icon': Icon
  },
  props: {},
  data () {
    return {
      title: '',
      name: '',
      correo: '',
      telefono: '',
      rut: '',
      ciudad: '',
      filial: '',
      mensaje: '',
      nameD: '',
      correoD: '',
      telefonoD: '',
      rutD: '',
      filialD: '',
      ciudadD: '',
      mensajeD: '',
      text: '',
      errormsg: '',
      type: ''
    }
  },
  computed: {},
  created () {
    // Señales recibidas
    serverUI.$on('FormEvent', (e) => {
      if (e.form !== 'CCUFormularioOtros') return
      if (e.evento === 'newdata') {
        this.title = e.dato.title ? e.dato.title : 'Formulario Consulta'
        this.nameD = e.dato.fields.name ? e.dato.fields.name : ''
        this.correoD = e.dato.fields.email ? e.dato.fields.email : ''
        this.telefonoD = e.dato.fields.phone ? e.dato.fields.phone : ''
        this.mensajeD = e.dato.fields.mensaje ? e.dato.fields.mensaje : ''
        this.rutD = e.dato.fields.rut ? e.dato.fields.rut : ''
        this.ciudadD = e.dato.fields.ciudad ? e.dato.fields.ciudad : ''
        this.filialD = e.dato.fields.filial ? e.dato.fields.filial : ''
        // data
        this.name = this.nameD
        this.correo = this.correoD
        this.telefono = this.telefonoD
        this.rut = this.rutD
        this.ciudad = this.ciudadD
        this.mensaje = this.mensajeD
        this.filial = this.filialD
      }
    })
  },
  methods: {
    _clearError () {
      this.errormsg = ''
    },
    focusTo (el) {
      this.$refs[el].focus()
    },
    _formatearRut (val) {
      this.rut = utils.cleanSpecialChars(val, 'rut')
      this.rut = utils.formatearRut(this.rut)
    },
    keyPressCheckSpecialChars (evt, type) {
      return utils.keyPressCheckSpecialChars(evt, type)
    },
    cleanSpecialChars (val, type) {
      if (!val) return
      return (this[val] = utils.cleanSpecialChars(this[val], type))
    },
    _sentClick () {
      this.errormsg = ''
      if (!this.name) {
        this.$refs.name.focus()
        this.errormsg = 'Debes ingresar nombre'
        return
      }
      if (!this.correo) {
        this.$refs.correo.focus()
        this.errormsg = 'Debes ingresar correo'
        return
      }
      if (!this.telefono) {
        this.$refs.telefono.focus()
        this.errormsg = 'Debes ingresar telefono'
        return
      }
      if (!this.rut) {
        this.$refs.rut.focus()
        this.errormsg = 'Debes ingresar rut'
        return
      }
      if (!this.ciudad) {
        this.$refs.ciudad.focus()
        this.errormsg = 'Debes ingresar ciudad'
        return
      }
      if (!this.filial) {
        this.$refs.filial.focus()
        this.errormsg = 'Debes ingresar una filial'
        return
      }
      if (!this.mensaje) {
        this.errormsg = 'Debes ingresar mensaje'
        return
      }
      let typeForm = ''
      let titleForm = ''
      console.log(this.title)
      if (this.title === 'Formulario Proveedor')
      { typeForm = 'ccu-camion-otros-form-confirm-supplier'
        titleForm = this.title }
      else if (this.title === 'Formulario Auspicio')
      { typeForm = 'ccu-camion-otros-form-confirm-auspice'
        titleForm = this.title }
      else if (this.title === 'Formulario Donación')
      { typeForm = 'ccu-camion-otros-form-confirm-donation'
        titleForm = this.title }
      else if (this.title === 'Formulario Consultas')
      { typeForm = 'ccu-camion-otros-form-confirm'
        titleForm = this.title }

      serverUI.$emit('FormEvent', {
        form: 'CCUFormularioOtros',
        evento: 'sentClick',
        data: {
          type: typeForm,
          fields: {
            title: titleForm,
            name: this.name,
            correo: this.correo,
            telefono: this.telefono,
            rut: this.rut,
            ciudad: this.ciudad,
            mensaje: this.mensaje,
            filial: this.filial
          }
        }
      })
    },
    _cancelClick () {
      serverUI.$emit('FormEvent', {
        form: 'CCUFormularioOtros',
        evento: 'cancelClick',
        dato: 'Cancelado'
      })
    }
  }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss" scoped>
.form__field {
  margin-bottom: 7px;
}

.form-box-body {
    height: 340px;
}
</style>
